__turbopack_context__.v({
  "body": "CandidateProfileCard-module__WnTgfG__body",
  "card": "CandidateProfileCard-module__WnTgfG__card",
  "content": "CandidateProfileCard-module__WnTgfG__content",
  "description": "CandidateProfileCard-module__WnTgfG__description",
  "editButton": "CandidateProfileCard-module__WnTgfG__editButton",
  "editIcon": "CandidateProfileCard-module__WnTgfG__editIcon",
  "highlights": "CandidateProfileCard-module__WnTgfG__highlights",
  "name": "CandidateProfileCard-module__WnTgfG__name",
  "photo": "CandidateProfileCard-module__WnTgfG__photo",
  "photoColumn": "CandidateProfileCard-module__WnTgfG__photoColumn",
  "photoWrapper": "CandidateProfileCard-module__WnTgfG__photoWrapper",
  "positionTitle": "CandidateProfileCard-module__WnTgfG__positionTitle",
  "statusChip": "CandidateProfileCard-module__WnTgfG__statusChip",
  "tabs": "CandidateProfileCard-module__WnTgfG__tabs",
  "updateAvatarButton": "CandidateProfileCard-module__WnTgfG__updateAvatarButton",
});
